export const MODAL_WIDTH_SMALLEST = '507px';
export const MODAL_WIDTH_SMALL = '576px';
export const MODAL_WIDTH_SMALLER = '600px';
export const MODAL_WIDTH_DEFAULT = '672px';
export const MODAL_WIDTH_MEDIUM = '816px';
